var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7292 13.8542C20.7292 13.1986 20.2318 12.6667 19.6187 12.6667H18.5082V10.2917C18.5082 9.42578 17.8373 8.70833 17.0275 8.70833H11.1049V6.33333H12.2154C12.8285 6.33333 13.3259 5.80143 13.3259 5.14583V1.1875C13.3259 0.531901 12.8285 0 12.2154 0H8.51377C7.90068 0 7.40327 0.531901 7.40327 1.1875V5.14583C7.40327 5.80143 7.90068 6.33333 8.51377 6.33333H9.62426V8.70833H3.70164C2.8919 8.70833 2.22098 9.42578 2.22098 10.2917V12.6667H1.11049C0.497407 12.6667 0 13.1986 0 13.8542V17.8125C0 18.4681 0.497407 19 1.11049 19H4.81213C5.42521 19 5.92262 18.4681 5.92262 17.8125V13.8542C5.92262 13.1986 5.42521 12.6667 4.81213 12.6667H3.70164V10.2917H9.62426V12.6667H8.51377C7.90068 12.6667 7.40327 13.1986 7.40327 13.8542V17.8125C7.40327 18.4681 7.90068 19 8.51377 19H12.2154C12.8285 19 13.3259 18.4681 13.3259 17.8125V13.8542C13.3259 13.1986 12.8285 12.6667 12.2154 12.6667H11.1049V10.2917H17.0275V12.6667H15.917C15.304 12.6667 14.8065 13.1986 14.8065 13.8542V17.8125C14.8065 18.4681 15.304 19 15.917 19H19.6187C20.2318 19 20.7292 18.4681 20.7292 17.8125V13.8542Z",
    fill: "#9EA9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeViewIcon);
export default __webpack_public_path__ + "static/media/TreeViewIcon.3b5d6d53512eaa7607b87a3a0c1709d8.svg";
export { ForwardRef as ReactComponent };